











































import store from '@/store';
import Global from '@/common/global.js'
import TextBox from '@/views/atoms/TextBox.vue'
import FlexRow from '@/views/molecules/FlexRow.vue'
import SearchButton from '@/views/atoms/SearchButton.vue'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import ApiClient from '@/common/api'
import saveAs from 'file-saver'
import ChoiceCheckBox from '@/views/organisms/ChoiceCheckBox.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'

export default
  name: 'ImageUpload'

  components: {
    TextBox
    FlexRow
    SearchButton
    ErrorLabel
    BlueButton
    ChoiceCheckBox
    CheckBox
  }

  props:
    src:
      type: String
      default: ''
    name:
      type: String
      default: ''
    imageName:
      type: String
      default: ''
    image:
      type: String
      default: ''
    nameValue:
      type: String
      default: ''
    index:
      type: Number
      default: null
    group:
      type: String
      default: null
    errorGroup:
      type: String
      default: null
    ctrl_length:
      type: Number
      default: false
    customer_id:
      type: String
      default: ''
    login_customer_id:
      type: String
      default: ''
    file_url:
      type: String
      default: ''
    nameSelect:
      type: Boolean
      default: false
    row:
      type: Object
    aclSave:
      type: Boolean
      default: true
    mblSave:
      type: Boolean
      default: true
    hblSave:
      type: Boolean
      default: true
    isPartner:
      type: Boolean
      default: false

  watch: {
    href: (val) ->
      @href = val
    fileKindVal: (e) ->
      @fileKindVal = e
  }

  data: ()->
    dropping: false
    imageSrc: ''
    fileNameVal: ''
    dragOverTimer: null
    customMaterial: Global.customMaterial()
    customMaterialEn: Global.customMaterialEn()
    fileKindVal: ''
    extension: ''

  created: () ->
    ext = @row.file_name.split('.')
    @extension = ext[1]

  computed: {
    isDropping: () ->
      return @dropping
    source: () ->
      return @imageSrc
    dropAreaName: () ->
      if @index == null
        return 'drop_area'
      return 'drop_area' + @index
    ctrlFileSelectName: () ->
      if @index == null
        return 'file_select'
      return 'file_select' + @index
  }

  mounted: () ->
    if (!Global.hasGroupIndexValue(@group, @index, @name))
      @_saveStore('', @index)
    # ドラッグアンドドロップ制御
    ctrl = document.querySelector('#' + @dropAreaName)
    ctrl.addEventListener 'dragstart', (e) =>
      @dropping = true
    , false
    ctrl.addEventListener 'dragover', (e) =>
      e.preventDefault()
      @dropping = true
      if @dragOverTimer
        clearTimeout(@dragOverTimer)
      @dragOverTimer = setTimeout () =>
        @dropping = false
      , 200
    , false
    ctrl.addEventListener 'drop', (e) =>
      e.preventDefault()
      @dropping = false

      if e.dataTransfer.files.length == 0
        return
      i = @index
      for row, index in e.dataTransfer.files
        @setImage(row, i)
        i++
    , false

    # ファイルセレクタ制御
    document.querySelector('#' + @ctrlFileSelectName).addEventListener 'change', (e) =>
      if e.target.files.length == 0
        return
      @setImage(e.target.files[0], @index)
    , false

  updated: () ->
#    @imageSrc = @image
#    @fileNameVal = @nameValue

  methods: {
    openImage: () ->
      document.querySelector('#' + @ctrlFileSelectName).click()
    text_change: (e) ->
      @$emit('change', e)
    setImage: (file, i) ->
      fileName = file.name
      if @customer_id != @login_customer_id
        return
#      if !@nameSelect
#        fileName = file.name
#      else if @fileNameVal == ''
#        fileName = @customMaterial[0].name
#        ext = file.name.split('.')
#        @extension = ext[1]
#        fileName = fileName + '.' + @extension
#      else
#        fileNameVal = @fileNameVal.split('.')
#        fileName = fileNameVal[0]
#        ext = file.name.split('.')
#        @extension = ext[1]
#        fileName = fileName + '.' + @extension

      @fileNameVal = fileName
      reader = new FileReader()
      reader.onload = (e) =>
        @imageSrc = e.target.result
        @_saveStore(@imageSrc, i)
        @$emit('change', {val: e.target.result, name: @imageName, index: i})
        @$emit('change', {val: fileName, name: @name, index: i})
      reader.readAsDataURL(file)
    delete_button: (e) ->
      @$emit('delete_button', e)
    _saveStore: (value, index) ->
      store.dispatch('setPostParam', {label: @imageName, value: value, index: index, group: @group})
    download: () ->
      if @file_url != '' && @nameValue != ''
        api = new ApiClient()
        data = await api.confirmGetFile(@file_url.replaceAll('#', '%23'))
        if data
          saveAs(@file_url.replaceAll('#', '%23'), @nameValue)
    downloadChecked: (e) ->
      # console.log e
      @$emit('downloadChecked', e)
    downloadChange: (e) ->
      # console.log e
      @$emit('downloadChange', e)
  }

